import { IonButton, IonIcon } from '@ionic/react';
import classNames from 'classnames';
import { closeOutline } from 'ionicons/icons';

import NFCAnimation from '@/components/NFCAnimation/NFCanimation';

import styles from './NFCAnimationModal.module.scss';

export interface NFCAnimationModalProps {
  onDismiss: (next: boolean) => void;
}

export default function NFCAnimationModal({
  onDismiss,
}: NFCAnimationModalProps) {
  return (
    <div id="bottom-modal-nfc-animation" className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleContainer}>
          <p className={styles.title}>¿Cómo leer el DNI?</p>
          <div className={styles.closeButton}>
            <IonIcon
              id="button-close-logout-modal"
              icon={closeOutline}
              onClick={() => onDismiss(false)}
            />
          </div>
        </div>
        <p className={styles.description}>
          Acerca el DNI a la parte posterior del teléfono en
          la posición en la que se muestra en la animación.
        </p>
      </div>
      <NFCAnimation />
      <IonButton
        className={classNames('nextButton', styles.continueButton)}
        onClick={() => onDismiss(true)}
      >
        Entendido
      </IonButton>
    </div>
  );
}
